import { createUseMutationHook } from 'hooks/createUseMutationHook';

export const useServiceUpdate = createUseMutationHook(
    'service_update',
    service_id => [
        ['service_detail', service_id],
    ],
);
